<template>
    <div>
        <div class="logo-container">
            <img v-if="configure===true" :src="loginlogo.configureValue" class="logo-img"/>
            <img v-else :src="logo" class="logo-img"/>
        </div>
        <el-menu :collapse="isCollapse" :default-active="$route.path" class="menu-yx" mode="vertical" theme="dark"
                 unique-opened>
            <sidebar-item :routes='permission_routers'></sidebar-item>
        </el-menu>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import SidebarItem from './SidebarItem';
//import logo from '@/assets/imgs/jl_logo_small.png'
import logo from '@/assets/imgs/logo-index.png'
import {getCompanyWithKey} from  "@/api/company"
import {getToken} from '@/utils/auth';
export default {
    components: {SidebarItem},
    computed: {
        ...mapGetters([
            'permission_routers',
            'sidebar'
        ]),
        isCollapse() {
            return !this.sidebar.opened
        }
    },
    data() {
        return {
            logo: logo,
            loginlogo:{},
            configure:false
        }
    },
    created(){
       this.getCompanyWithKey()
    },
    methods:{
        getCompanyWithKey(){
            let token= getToken();
            getCompanyWithKey({token}).then((response)=>{
                response.data.forEach(element => {
                    if(element.configureKey==='mainLogoPath'){
                        this.loginlogo=element;
                    }
                })
                if(this.checkConfigureValue(this.loginlogo)===true){
                    this.configure=true
                }else {
                    this.configure=false;
                }
                console.log(this.loginlogo.configureValue,this.configure,this.loginlogo,"logo");
            }).catch(()=>{
                this.configure=false;
            })
        },
        checkConfigureValue(obj) {
            // 检查对象是否有 configureValue 属性
            if (obj && obj.hasOwnProperty('configureValue')) {
                // 获取 configureValue 的值
                const value = obj.configureValue;

                // 检查 configureValue 是否为空
                if (value === null || value === undefined || value === '') {
                    return false; // 是空
                } else {
                    return true; // 不是空
                }
            }

            return false; // 对象不存在 configureValue 属性
        },
    },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
/*.menu-yx{*/
/*background-color: RGB(46,161,230);*/
/*color: red;*/
/*}*/
/*.el-menu-item.is-active {*/
/*background-color: white !important;*/
/*}*/
.logo-container {
    background-color: #0f9cdd;
    text-align: center;
}

.logo-img {
    max-width: 60%;
    max-height: 60%;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?1dc71598